<script lang="ts">
	import { getChartsSharedOptions } from '@app/utils/charts';
	import './CarbonChartsStyles.css';
	import { BarChartStacked } from '@carbon/charts-svelte';

	export let data;
	export let title;
	export let height;

	let specificOptions = {
		axes: {
			left: {
				mapsTo: 'value',
				stacked: true
			},
			bottom: {
				mapsTo: 'date',
				scaleType: 'time'
			}
		}
	};

	$: options = { ...specificOptions, ...getChartsSharedOptions(data, title, height) };
</script>

<svelte:component this={BarChartStacked} {data} {options} />
